"use client";

import { useMemo } from "react";
import { type Situation } from "@/generated/fastapi";

export default function useSituationItems(situations?: Situation[] | null) {
  return useMemo(
    () =>
      (situations ?? []).map((situation) => ({
        label: situation.abbr ?? situation.id,
        value: situation.id,
      })),
    [situations],
  );
}
